class GiftMessage extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('input[type="checkbox"]');
    this.content = this.querySelector('.gift-message__content');
    this.giftFallback = this.querySelector('.gift-message__gift-fallback');
    this.message = this.querySelector('textarea');
    this.messageFallback = this.querySelector('.gift-message__message-fallback');

    this.toggle.addEventListener('change', () => this.sync());
    this.sync();
  }

  sync() {
    const isGift = this.toggle.checked;

    this.content.hidden = !isGift;
    this.giftFallback.disabled = isGift;
    this.message.disabled = !isGift;
    this.message.required = isGift;
    this.messageFallback.disabled = isGift;
  }
}

if (!customElements.get('gift-message')) {
  customElements.define('gift-message', GiftMessage);
}
